<template lang="pug">
.modal-window(role="dialog" :aria-labelledby="uniqueId")
	.modal-window__header
		.h2(v-if="title" :id="uniqueId") {{ prefix ? `${prefix} ${title}` : title }}
		button.modal-window__close.js-close-modal(type="button" aria-label="Закрыть" @click="onClick")
			v-svg-icon.modal-window__close-icon(:icon=" icon ? icon : 'close'")
	.modal-window__body
		slot
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	props: {
		title: {
			type: String,
			default: ''
		},

		prefix: {
			type: String,
			default: ''
		},

		icon: {
			type: String,
			default: ''
		},

		actions: {
			type: Object,
			default: {}
		}
	},

	data() {
		return {
			uniqueId: uniqueId('modal-'),
			active: true,
			redirect: null,
		};
	},

	methods: {
		onClick() {
			if(this.redirect) {
				window.location.href = this.redirect;
			}
		}
	},

	watch: {
		action: {
			immediate: true,
			handler() {
				this.redirect = this.actions.redirect
			}
		},
	},

	beforeUnmount() {
		if(this.redirect) {
			return window.location.href = this.redirect;
		}
	}

};
</script>